import axios from 'axios'

// Ref do token em memória — atualizado pelo AuthContext
let _accessToken: string | null = null

export function setAccessToken(token: string | null) {
  _accessToken = token
}

export function getAccessToken(): string | null {
  return _accessToken
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3002',
  withCredentials: true, // envia cookie refresh_token automaticamente
  timeout: 15000,
})

// Injeta Bearer token em todas as requests
api.interceptors.request.use((config) => {
  if (_accessToken) {
    config.headers.Authorization = `Bearer ${_accessToken}`
  }
  return config
})

// Tratamento global de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url = error.config?.url ?? ''
    const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/invite') || url.includes('/auth/accept-invite')
    const onLoginPage = window.location.pathname.startsWith('/login')

    if (status === 401 && !isAuthRoute && !onLoginPage) {
      setAccessToken(null)
      const currentPath = window.location.pathname + window.location.search
      window.location.href = `/login?returnUrl=${encodeURIComponent(currentPath)}`
    }
    return Promise.reject(error)
  }
)
